import JsCookies from 'js-cookie';

import AbstractView from 'abstracts/AbstractView';

import Main from 'controllers/Main';

import InfoMessage from 'components/statics/infos-message/js/InfoMessage';



export default new class Cookies extends AbstractView {
	
	constructor() {
		super();
	}
	
	
	initDOM() {
		super.initDOM();
		
		this.$wrapper   = $( '#seikooc' );
		this.$btnAccept = this.$wrapper.find( '.seikooc--btn__accept' );
		this.$btnRefuse = this.$wrapper.find( '.seikooc--btn__refuse' );
	}
	
	
	bindEvents() {
		super.bindEvents();
		
		this.eh.clickBtnAccept = this._accept.bind( this );
		this.$btnAccept.on( 'click', this.eh.clickBtnAccept );
		this.eh.clickBtnRefuse = this._refuse.bind( this );
		this.$btnRefuse.on( 'click', this.eh.clickBtnRefuse );
	}
	
	
	checkCookiesAccepted() {
		const cookiesAccepted = JsCookies.get( 'cookies-has_accepted' );
		
		if ( cookiesAccepted === undefined )
			this.$wrapper[ 0 ].style.display = 'block';
		else if ( cookiesAccepted === 'true' ) {
			this._activateScripts();
			InfoMessage.show();
		}
		else if ( cookiesAccepted === 'false' )
			InfoMessage.show();
	}
	
	
	_refuse() {
		this._setCookiesAcceptance( 'false' );
		this._hide();
	}
	
	
	_accept() {
		this._setCookiesAcceptance( 'true' );
		this._activateScripts();
		this._hide();
	}
	
	
	_setCookiesAcceptance( value ) {
		JsCookies.set( 'cookies-has_accepted', value, { expires: 30 } );
	}
	
	
	_activateScripts() {
		const $scripts = Main.$html.find( 'script.cookies_to_accept' );
		
		$scripts.each( ( i, $el ) => {
			if ( $el.src ) {
				const src = $el.src;
				$el.src   = '';
				$el.type  = 'text/javascript';
				$el.src   = src;
			}
			else {
				const inner   = $el.innerText.replace( /(\r\n|\n|\r|\t)/gm, '' ); // remove all tabs & line breaks
				$el.innerText = '';
				$el.type      = 'text/javascript';
				$el.innerText = inner;
			}
		} );
	}
	
	
	_hide() {
		this.tl.hide = gsap.timeline( {
			onComplete: this._onHideComplete.bind( this )
		} )
			.to( this.$wrapper, { duration: 0.3, x: 20, opacity: 0, ease: 'power2.out' }, 0 );
	}
	
	
	_onHideComplete() {
		this.$wrapper[ 0 ].style.display = 'none';
		
		InfoMessage.show( true );
	}
	
};

